<template>
  <b-modal
    id="modal-share-temp-tracking"
    modal-class="mc-modal-link"
    :title="title"
    size="md"
    centered
    scrollable
  >
    <b-list-group class="mc-general__label">
      <b-list-group-item href="#" @click="handleCopyLink">
        <i class="mc-icon fas fa-link me-1"></i>
        <span class="mc-general__label">{{ $t('global.action.copyLink') }}</span>
      </b-list-group-item>
      <b-list-group-item href="#" @click="handleViewTracking">
        <i class="mc-icon icon-outline_map me-1"></i>
        <span class="mc-general__label">{{ $t('global.action.share.viewTracking') }}</span>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <McButton
        variant="secondary"
        class="me-2"
        :text="$t('global.action.cancel')"
        @click="$bvModal.hide('modal-share-temp-tracking')"
      />
    </template>
  </b-modal>
</template>

<script>
import { MixPanel } from '@/mixin/mixpanel'
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  mixins: [MixPanel],
  props: {
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleCopyLink() {
      this.track('Pelacakan Sementara Copy Link Clicked')

      navigator.clipboard.writeText(this.link)
      this.$mcToast.success('Tautan berhasil disalin')
      this.$bvModal.hide('modal-share-temp-tracking')
    },

    handleViewTracking() {
      this.track('Pelacakan Sementara View Tracking Clicked')

      window.open(this.link, '_blank')
      this.$bvModal.hide('modal-share-temp-tracking')
    },
  },
}
</script>
